module.exports = __webpack_public_path__ + "static/media/material.cb2f65a2.svg";